module.exports = __webpack_public_path__ + "static/media/record-2.44996ce1.png";